/******************************
 INIZIALIZZAZIONE GOOGLE TAG MANAGER
 *****************************/

(function() {
    'use strict';

    /**
     * Inizializza il dataLayer di Google Tag Manager
     */
    function initDataLayer() {
        window.dataLayer = window.dataLayer || [];
    }

    /**
     * Funzione gtag per pushare eventi nel dataLayer
     */
    function gtag() {
        window.dataLayer.push(arguments);
    }

    /**
     * Costruisce l'oggetto consentModes con i valori di default
     * @param {Object} baseConsent - Oggetto con i valori personalizzati di consent
     * @returns {Object} - Oggetto completo con tutti i consent modes
     */
    function buildConsentModes(baseConsent) {
        return Object.assign({
            ad_storage: 'denied',
            analytics_storage: 'denied',
            functionality_storage: 'granted',
            security_storage: 'granted',
            ad_personalization: 'denied',
            ad_user_data: 'denied'
        }, baseConsent);
    }

    /**
     * Configura gtag con i parametri specifici
     * @param {Object} consentModes - Oggetto con i consent modes
     * @param {String} type - Tipo di configurazione ('default' o 'update')
     * @param {String} accountId - ID dell'account Google Analytics
     */
    function configureGtag(consentModes, type, accountId) {
        var config = {
            allow_google_signals: consentModes.ad_personalization === 'granted',
            allow_ad_personalization_signals: consentModes.ad_personalization === 'granted'
        };

        if (type === 'default') {
            config.wait_for_update = 500;
        }

        gtag('config', accountId, config);
    }

    /**
     * Invia i consent modes a Google Tag Manager
     * @param {Object} consentModes - Oggetto con i consent modes
     * @param {String} type - Tipo di consent ('default' o 'update')
     * @param {String} accountId - ID dell'account Google Analytics
     * @param {Object} pageData - Dati della pagina corrente
     */
    function sendConsentToGTM(consentModes, type, accountId, pageData) {
        gtag('consent', type, consentModes);

        if (consentModes.ad_user_data === 'granted' && typeof window.GTagUserData !== 'undefined') {
            gtag('set', 'user_data', window.GTagUserData);
        }

        gtag('set', 'url_passthrough', consentModes.analytics_storage === 'denied' || consentModes.ad_storage === 'denied');
        gtag('set', 'ads_data_redaction', consentModes.ad_storage === 'denied');
        configureGtag(consentModes, type, accountId);

        if (GTM && pageData) {
            GTM.send('page_view', {
                page_title: pageData.page_title,
                page_location: pageData.page_location
            });
        }
    }

    /**
     * Inizializza Google Tag Manager con i dati forniti
     */
    function initGTM() {
        // Legge i dati di configurazione dal tag script JSON
        var gtmConfigElement = document.getElementById('gtm-config-data');
        if (!gtmConfigElement) {
            return;
        }

        var gtmConfig;
        try {
            gtmConfig = JSON.parse(gtmConfigElement.textContent);
        } catch (e) {
            console.error('Errore nel parsing dei dati GTM:', e);
            return;
        }

        // Inizializza il dataLayer
        initDataLayer();

        // Imposta i dati utente se presenti
        if (gtmConfig.userData) {
            window.GTagUserData = gtmConfig.userData;
        }

        // Costruisce i consent modes di default
        var defaultConsentModes = buildConsentModes(gtmConfig.defaultConsent || {});

        // Invia il consent di default a GTM
        sendConsentToGTM(
            defaultConsentModes,
            'default',
            gtmConfig.accountId,
            gtmConfig.pageData
        );

        // Pusha i dati addizionali nel dataLayer
        if (gtmConfig.pushData && gtmConfig.pushData.length > 0) {
            gtmConfig.pushData.forEach(function(data) {
                window.dataLayer.push(data);
            });
        }

        // Se ci sono consent già forniti dall'utente, inviali come update
        if (gtmConfig.hasConsents && gtmConfig.userConsent) {
            var consentModes = buildConsentModes(gtmConfig.userConsent);
            sendConsentToGTM(
                consentModes,
                'update',
                gtmConfig.accountId,
                null // Non è necessario inviare di nuovo i dati della pagina
            );
        }

        // Espongo buildConsentModes e sendConsentToGTM globalmente per compatibilità
        // con eventuali script esterni che potrebbero utilizzarli (es. cookie-law.js).
        // Le espongo solo qui, dopo l'inizializzazione del dataLayer, per evitare
        // errori quando GTM non è attivo.
        window.buildConsentModes = buildConsentModes;
        window.sendConsentToGTM = sendConsentToGTM;
    }

    // Inizializza GTM quando il DOM è pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGTM);
    } else {
        initGTM();
    }

})();
